// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { MediaDataCollection } from "@bg/App/Services/MediaDataService";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type MediaDataState = {
    mediaDataCollection: MediaDataCollection;
    isLoading: boolean;
};

export type xMediaDataState = {
    xMediaData: MediaDataState;
};

const initialMediaDataState: MediaDataState = {
    mediaDataCollection: {
        success: true,
        data: [],
    },
    isLoading: false,
};

const xMediaData = createTypedReducerWithImmer(initialMediaDataState, {
    "xMediaData/BeginLoadMediaData": (draft: Draft<MediaDataState>) => {
        draft.isLoading = true;
    },
    "xMediaData/CompleteLoadMediaData": (draft: Draft<MediaDataState>, action: { mediaData: MediaDataCollection }) => {
        draft.mediaDataCollection = action.mediaData!;
        draft.isLoading = false;
    },
});

(reducers as any).xMediaData = xMediaData;

type xMediaDataReducers = {
    mediaData: typeof xMediaData;
};

export type xMediaDataActions = Parameters<xMediaDataReducers[keyof xMediaDataReducers]>[1] | AnyAction;
